var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"rims-config-wheel-design-overview"},[_c('rimconfig-breadcrumb',{attrs:{"breadcrumb-items":_vm.breadcrumbItems},on:{"on-click-brand":_vm.onClickBrand}}),_c('wheel-design-overview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }